import LandingPage from "./pages/onBoarding/LandingPage";
import SignUp from "./pages/auth/SignUp";
import SignIn from "./pages/auth/SignIn";
import Dashboard from "./pages/dashboard/Dashboard";
import SelectAccount from "./components/onBoarding/SelectAccount";
import RequireAuth from "./hooks/RequireAuth";
import { createBrowserRouter } from "react-router-dom";
import VerifyEmail from "./pages/auth/verifyEmail";
import VerificationSuccessful from "./pages/auth/verificationSuccessful";
import VerifyPhoneNumber from "./pages/auth/verifyPhoneNumber";
import { routerPaths } from "./services/path";
import Boat from "./pages/boat/Boat";
import BoatDetails from "./pages/boat/CreateBoat";
import Settings from "./pages/settings/Settings";
import Profile from "./pages/profile/Profile";
import Booking from "./pages/booking/booking";
import Wallet from "./pages/wallet/Wallet";
import CreateWallet from "./pages/wallet/CreateWallet";
import HireHistory from "./pages/hireHistory/HireHistory";
import Transactions from "./pages/wallet/Transactions";
import NotFoundPage from "./pages/NotFoundPage";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import EditPhotos from "./pages/boat/EditPhotos";
import EditPricing from "./components/booking/Edit_pricing";
import RegistrationDocument from "./pages/auth/RegistrationDocument";


const router = createBrowserRouter([
  {
    path: routerPaths.landingPage,
    element: <LandingPage />,
  },
  {
    path: routerPaths.selectAccount,
    element: <SelectAccount />,
  },
  {
    path: routerPaths.signIn,
    element: <SignIn />,
  },
  {
    path: routerPaths.signUp,
    element: <SignUp />,
  },
  {
    path: routerPaths.verifyEmail,
    element: <VerifyEmail />,
  },
  {
    path: routerPaths.verifyPhoneNumber,
    element: <VerifyPhoneNumber />,
  },
  {
    path: routerPaths.verificationSuccessful,
    element: <VerificationSuccessful />,
  },
  {
    path: routerPaths.forgotPassword,
    element: <ForgotPassword />,
  },
  {
    path: routerPaths.resetPassword,
    element: <ResetPassword />,
  },
  {
    path: routerPaths.registrationDocument,
    element: <RegistrationDocument />,
  },
  //dashboard

  {
    path: routerPaths.dashboard,
    element: (
      <RequireAuth>
        <Dashboard />
      </RequireAuth>
    ),
  },
  //boat
  {
    path: routerPaths.boat,
    element: (
      <RequireAuth>
        <Boat />
      </RequireAuth>
    ),
  },
  {
    path: routerPaths.createBoat,
    element: (
      <RequireAuth>
        <BoatDetails />
      </RequireAuth>
    ),
  },
  {
    path: routerPaths.editPhotos,
    element: (
      <RequireAuth>
        <EditPhotos />
      </RequireAuth>
    ),
  },
  {
    path: routerPaths.editPricing,
    element: (
      <RequireAuth>
        <EditPricing />
      </RequireAuth>
    ),
  },
  //Settings
  {
    path: routerPaths.settings,
    element: (
      <RequireAuth>
        <Settings />
      </RequireAuth>
    ),
  },
  //Profile
  {
    path: routerPaths.profile,
    element: (
      <RequireAuth>
        <Profile />
      </RequireAuth>
    ),
  },
  //bookings
  {
    path: routerPaths.booking,
    element: (
      <RequireAuth>
        <Booking />
      </RequireAuth>
    ),
  },

  //wallet
  {
    path: routerPaths.wallet,
    element: (
      <RequireAuth>
        <Wallet />
      </RequireAuth>
    ),
  },
  {
    path: routerPaths.createWallet,
    element: (
      <RequireAuth>
        <CreateWallet />
      </RequireAuth>
    ),
  },
  {
    path: routerPaths.hireHistory,
    element: (
      <RequireAuth>
        <HireHistory />
      </RequireAuth>
    ),
  },
  {
    path: routerPaths.transaction,
    element: (
      <RequireAuth>
        <Transactions />
      </RequireAuth>
    ),
  },

  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

export default router;
